import React from "react";
import {
	Avatar,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
} from "@mui/material";

import { closeWhiteIcon } from "assets/images";
import "./ResponsiveDialog.css";
import {
	DialogTitleProps,
	ResponsiveDialogProps,
} from "./ResponsiveDialog.Props";

const BootstrapDialogTitle = (props: DialogTitleProps) => {
	const { children, onClose, ...other } = props;

	return (
		<DialogTitle {...other}>
			{children}
			{onClose ? (
				<IconButton aria-label="close" onClick={onClose} size="small">
					<Avatar src={closeWhiteIcon} alt="Close" variant="square" />
				</IconButton>
			) : null}
		</DialogTitle>
	);
};

const ResponsiveDialog: React.FC<ResponsiveDialogProps> = ({
	maxWidth,
	open,
	onCancel,
	onConfirm,
	title,
	titleCloseIcon = true,
	showActionButtons = true,
	showCloseBtn = true,
	cancelText = "Close",
	okText = "Save",
	children,
	fullWidth = false,
	contentClass = "",
	containerClass = "",
	dialogActionContent,
	onDialogClose, // handle dialog title close icon click
	disableOkButton = false,
	fullScreen = false,
}) => {
	return (
		<Dialog
			fullWidth={fullWidth}
			maxWidth={fullWidth || fullScreen ? false : maxWidth || "sm"}
			open={open}
			disableEnforceFocus
			scroll="paper"
			className={containerClass}
			fullScreen={fullScreen}
		>
			{(title || titleCloseIcon) && (
				<BootstrapDialogTitle
					onClose={titleCloseIcon ? onDialogClose || onCancel : undefined}
				>
					<div
						className="title-inner"
						style={!titleCloseIcon ? { padding: "9px 0" } : {}}
					>
						{title}
					</div>
				</BootstrapDialogTitle>
			)}
			<DialogContent
				className={`${contentClass} ${showActionButtons ? "" : "no-action"}`}
			>
				{children}
			</DialogContent>
			{showActionButtons && (
				<DialogActions>
					<Button
						onClick={onConfirm}
						variant="contained"
						disabled={disableOkButton}
					>
						{okText}
					</Button>
					{showCloseBtn && (
						<Button onClick={onCancel} variant="outlined">
							{cancelText}
						</Button>
					)}
				</DialogActions>
			)}
			{dialogActionContent && (
				<DialogActions>{dialogActionContent}</DialogActions>
			)}
		</Dialog>
	);
};

export default ResponsiveDialog;
